import axios from "axios";

const API_ENDPOINT = "form-submissions";
const PAYMENT_TOKEN_ENDPOINT_3D = API_ENDPOINT + "/payment_token_3d";
const AUTHENTICATION_TOKEN_ENDPOINT = API_ENDPOINT + "/authentication_token";
const PAYMENT_ATTEMPT_ENDPOINT = API_ENDPOINT + "/payment_attempt";
const PAYMENT_ATTEMPT_EU_ENDPOINT = API_ENDPOINT + "/payment_attempt_eu";

export default {
    save(formData, formType) {
        const form = new FormData();
        form.append("formType", formType);
        for (var key in formData) {
            for (var key2 in formData[key]) {
                form.append(`formData[${key}][${key2}]`, formData[key][key2]);
            }
        }

        formData.project_details.images.forEach(function (image, i) {
            form.append(`files[${i}]`, image.raw);
        });
        formData.project_details_1.images.forEach(function (image, i) {
            form.append(`files_1[${i}]`, image.raw);
        });
        formData.project_details_2.images.forEach(function (image, i) {
            form.append(`files_2[${i}]`, image.raw);
        });

        formData.project_details.floorplans.forEach(function (file, i) {
            form.append(`files_floorplan_1[${i}]`, file);
        });
        formData.project_details_1.floorplans.forEach(function (file, i) {
            form.append(`files_floorplan_2[${i}]`, file);
        });
        formData.project_details_2.floorplans.forEach(function (file, i) {
            form.append(`files_floorplan_3[${i}]`, file);
        });

        return axios.post(API_ENDPOINT, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    getAuthenticationToken() {
        return axios.post(AUTHENTICATION_TOKEN_ENDPOINT);
    },

    getPaymentToken(formId, threedsData) {
        return axios.post(PAYMENT_TOKEN_ENDPOINT_3D, {
            formId: formId,
            threedsData: threedsData,
        });
    },

    savePaymentAttempt(formId, status, paymentDetails) {
        return axios.post(PAYMENT_ATTEMPT_ENDPOINT, {
            formId: formId,
            paymentDetails: paymentDetails,
            status: status,
        });
    },

    savePaymentAttemptEu(formId, status, paymentDetails) {
        return axios.post(PAYMENT_ATTEMPT_EU_ENDPOINT, {
            formId: formId,
            paymentDetails: paymentDetails,
            status: status,
        });
    },
};
